|<template>
  <div>
    <Breadcrumbs main="Inventario" title="Productos"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-left">
                <b-button class="mr-2" variant="warning" size="sm" v-on:click="displayModalStock">
                  <feather type="box" style="height: 12px; width: 12px"></feather> Descargar inventario
                </b-button>
              </div>
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'InventoryProductForm'}">
                  <feather type="box" style="height: 12px; width: 12px"></feather> Agregar producto
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        @editDeletedObject="editDeletedObject"
                        @editObject="editObject"
                        @displayModalUpdateStockProduct="displayModalUpdateStockProduct"
                        @disableObject="disableObject">
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
    <b-modal id="edit-stock" centered title="Cambiar stock" ok-title="Cambiar Stock" cancel-title="Cerrar" @ok="updateStockProduct" class="theme-modal">
      <div class="" v-if="productEdit">
        <p class="text-center">
          Estás a punto de modificar el stock del producto <b>{{this.productEdit['name']}}</b>.
        </p>
        <div class="col-12 text-center">
          <img :src="productEdit['image']" alt="producto" class="img-thumbnail">
        </div>
        <p class="text-center">
          Stock actual:
          <span class="badge badge-primary">{{this.productEdit['invoice_stock']}}</span>
        </p>
        <div class="col-md-12 mb-3">
          <label>Nuevo stock (requerido)</label>
          <b-form-input
                  type="number" min="0"
                  v-model="productEditForm.stock.value">
          </b-form-input>
          <b-form-invalid-feedback :state="productEditForm.stock.is_valid">{{productEditForm.stock.message_error}}</b-form-invalid-feedback>
        </div>
        <div class="col-md-12 mb-3">
          <label for="stock_id">Razón del cambio (requerido)</label>
          <b-form-textarea rows="3"
                           v-model="productEditForm.worker_observation.value"></b-form-textarea>
          <b-form-invalid-feedback :state="productEditForm.worker_observation.is_valid">{{productEditForm.worker_observation.message_error}}</b-form-invalid-feedback>
        </div>
      </div>
    </b-modal>
    <b-modal id="download-inventory" centered title="Descargar Inventario" ok-title="Descargar" cancel-title="Cerrar" @ok="downloadStock" class="theme-modal">
      <div class="col-md-12 mb-3">
        <label for="client_id">Cliente (requerido)</label>
        <multiselect placeholder="Selecciona un cliente" id="client_id"
                     label="business_name" track-by="id"
                     deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                     v-model="formInventory.client.value" :options="formInventory.client.options"
                     :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
          <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
          <template slot="noOptions">No hay clientes disponibles.</template>
        </multiselect>
        <b-form-invalid-feedback :state="formInventory.client.is_valid">{{formInventory.client.message_error}}</b-form-invalid-feedback>
      </div>
      <div class="col-md-12 mb-3">
        <label>Formato (requerido)</label>
        <multiselect placeholder="Selecciona un formato"
                     label="name" track-by="id"
                     deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                     v-model="formInventory.type.value" :options="formInventory.type.options"
                     :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
          <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
          <template slot="noOptions">No hay formatos disponibles.</template>
        </multiselect>
        <b-form-invalid-feedback :state="formInventory.type.is_valid">{{formInventory.type.message_error}}</b-form-invalid-feedback>
      </div>
      <div class="offset-5" v-show="formInventory.isProcessing">
        <span class="rotate dotted"></span>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import fileDownload from "js-file-download";

  export default {
    components: {
      VdtnetTable,
      Multiselect
    },
    data(){
      return {
        productEdit: null,
        productEditForm: null,
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/inventory/v1.0/product/?format=datatables&deleted=false&category__status=true&category__deleted=false&client__status=true',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
            },
          },
          fields: {
            id: {
              data: 'id',
              name: 'id',
              visible: false,
              searchable: true,
            },
            full_name: {
              data: 'full_name',
              name: 'full_name',
              visible: false,
              sortable: false,
              searchable: true,
            },
            type: {
              data: 'type',
              name: 'type',
              visible: false,
              searchable: true,
            },
            pack_name: {
              data: 'pack_name',
              name: 'pack_name',
              visible: false,
              searchable: true,
            },
            image: {
              name: 'image',
              label: 'Imagen',
              data: 'image',
              sortable: false,
              searchable: false,
              render: function (data, type, row) {
                return `<img class="img-thumbnail" alt="imagen del producto" style="width: 90px" src="${row['image'].replace('http', 'https')}"/>`;
              }
            },
            name: {
              name: 'category__name',
              label: 'Producto',
              data: 'name',
              sortable: true,
              searchable: true,
              render: function (data, type, row) {
                if (data) return data;
                return row['pack_name'];
              }
            },
            client: {
              name: 'client__business_name',
              label: 'Cliente',
              data: 'client.business_name',
              sortable: true
            },
            category: {
              name: 'category__name',
              label: 'Categoría',
              data: 'category.name',
              sortable: true,
            },
            invoice_stock: {
              name: 'invoice_stock',
              label: 'Total de productos',
              data: 'invoice_stock',
              sortable: true,
            },
            invoice_stock_busy: {
              name: 'invoice_stock_busy',
              label: 'Productos en uso',
              data: 'invoice_stock_busy',
              sortable: true,
            },
            status: {
              name: 'status',
              label: 'Estado',
              data: 'status',
              render: function (data, type, row) {
                let status;
                if(row['status']){
                  status = '<span class="badge badge-success">Habilitado</span>';
                }else{
                  status = '<span class="badge badge-danger">Deshabilitado</span>';
                }
                return status;
              }
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function (data, type, row) {
                let status = '';
                let stock = '';
                if(row['status']){
                  status = '<a href="javascript:void(0);" data-action="disableObject" title="Deshabilitar"><span class="badge badge-warning"><i class="fa fa-times"></i></span></a>'
                }else{
                  status = '<a href="javascript:void(0);" data-action="disableObject" title="Habilitar"><span class="badge badge-success"><i class="fa fa-check"></i></span></a>'
                }

                if (row['type'] !== 'P') {
                  stock += '<a href="javascript:void(0);" data-action="displayModalUpdateStockProduct" title="Modificar Stock"><span class="badge badge-success"><i class="fa fa-plus"></i></span></a> '
                }

                return '' +
                        `${stock} ` +
                        '<a href="javascript:void(0);" data-action="editObject" title="Modificar"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                        `${status} ` +
                        '<a href="javascript:void(0);" data-action="editDeletedObject" title="Eliminar"><span class="badge badge-danger"><i class="fa fa-trash"></i></span></a>';
              }
            }
          },
          quickSearch: '',
        },
        formInventory: {
          client: utils.defaultFields({_type: 'select'}),
          type: utils.defaultFields({
            _type: 'select',
            options: [
              {'id': 'pdf', 'name': 'PDF'},
              {'id': 'excel', 'name': 'Excel'},
            ],
          }),
          isProcessing: false
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
      this.getClient(this.formInventory.client);
    },
    methods: {
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      editObject(data){
        this.$router.push({'name': 'InventoryProductFormEdit', params: { objectId: data['id'] }});
      },
      displayModalStock(){
        this.$bvModal.show('download-inventory');
      },
      async downloadStock(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        await bvModalEvt.preventDefault();
        // SI ES Q AMBOS ESTÁN SELECCIONADOS GENERAMOS LA DESCARGA
        if(this.formInventory.client.value.id && this.formInventory.type.value.id){
          this.formInventory.isProcessing = true;
          let path;
          if(this.formInventory.type.value['id'] === 'pdf'){
            path = `/api/inventory/v1.0/inventory_pdf/${this.formInventory.client.value.id}/`;
          } else {
            path = `/api/inventory/v1.0/inventory_excel/${this.formInventory.client.value.id}/`;
          }
          // window.open(path, '_blank');
          await axios.get(path, {responseType: "blob"}).then(async (response) => {
            let fileName;
            if(this.formInventory.type.value['id'] === 'pdf'){
              fileName = `${this.formInventory.client.value.business_name}-inventario.pdf`;
            } else {
              fileName = `${this.formInventory.client.value.business_name}-inventario.xlsx`;
            }
            fileDownload(response.data, fileName);
            // DEJAMOS LOS VALORES POR DEFECTO
            this.formInventory.client.value = null
            this.formInventory.type.value = null
            this.$bvModal.hide('download-inventory');
          }).catch(async (error) => {
            // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
            // console.log(error.response);
            if(error.response.status === 400){
              await this.$swal({
                title: 'Error',
                type: 'error',
                html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
              });
            }
          });
          this.formInventory.isProcessing = false;
        } else {
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
        // this.$swal({
        //   title: 'Error',
        //   type: 'error',
        //   html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
        // });
        //
      },
      async disableObject(row){
        let oldState = '';
        let newState = '';

        if(row['status']){
          oldState = 'Habilitado';
          newState = 'Deshabilitado';
        } else {
          oldState = 'Deshabilitado';
          newState = 'Habilitado';
        }

        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>cambiar el estado</b> del producto <b>${row['name']}</b> de <b>${oldState}</b> a <b>${newState}</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/product/' + row['id'] + '/';
            let data = {status: !row['status']};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if (response) {
              await this.$swal({
                title: 'Editado!',
                type: 'success',
                html: `Se ha editado el estado del producto de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
      async editDeletedObject(row) {
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>eliminar</b> el producto <b>${row['name']}</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/product/' + row['id'] + '/';
            let data = {deleted: true};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if(response){
              await this.$swal({
                title: 'Eliminado!',
                type: 'success',
                html: `Se ha eliminado el producto de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
      async displayModalUpdateStockProduct(row) {
        this.productEdit = row;
        this.productEditForm = {
          stock: utils.defaultFields({value: row['invoice_stock']}),
          worker_observation: utils.defaultFields()
        };
        await this.$bvModal.show('edit-stock');
      },
      updateStockProduct(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        bvModalEvt.preventDefault();
        let data = {};
        let isValid = utils.generateJsonStructure(this.productEditForm, data);
        // AGRGEO EL PRODUCTO
        data['product'] = this.productEdit['id'];
        if(isValid){
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de cambiar el stock del producto <b>${this.productEdit.name}</b> de <b>${this.productEdit.invoice_stock}</b> a <b>${this.productEditForm.stock.value}</b>. Se generará un registro al momento de realizar un cambio de stock.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/product_stock/';
              const response = await axios.post(path, data).then(() => {
                return true;
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                utils.generateBackendError(this.productEditForm, error.response.data);
                await this.$swal({
                  title: 'Error',
                  type: 'error',
                  html: 'Ha ocurrido un error inesperado, inténtalo nuevamente. Si el problema consiste, póngase en contacto con el administrador del sistema.',
                });
                return false;
              });
              // SI SE REALIZA EL CAMBIO
              if(response){
                // ESCONDEMOS EL MODAL
                this.$bvModal.hide('edit-stock');
                await this.$swal({
                  title: 'Editado',
                  type: 'success',
                  html: `Se ha cambiado el estado del despacho de manera correcta.`,
                });
                // CAMBIAMOS EL ESTADO
                this.reloadTable();
              }
            }
          });
        }
      },
      getClient(clientField){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            clientField.options = response.data;
          }
        });
      },
    },
  }
</script>

<style>
  table img {
    width: 100px;
    height: 100px;
  }
</style>